import { createAsyncThunk } from '@reduxjs/toolkit';
import { removeLoading } from '../appAction';
import { Enums, Paths, Value } from '@utils/constants';
import { axios } from '@utils/lib';

export const getFaceDbListAsync = createAsyncThunk(
  'api/getFaceDbListAsync',
  async (query: IFaceDbQuery, { rejectWithValue, dispatch }) => {
    //   dispatch(addLoading());
    const { accessToken, type, ...rest } = query;
    const searchQuery: Record<string, string> = {
      page: rest.page ?? Value.TABLE_PAGE_INIT,
      pageSize: rest.pageSize ?? Value.TABLE_PAGE_SIZE,
      sort: 'id:desc',
    };
    if (rest.name) searchQuery.name = rest.name;
    const params = new URLSearchParams(searchQuery).toString();

    try {
      const { data } = await axios.request<IListRes<IFaceDbData>>(
        Enums.HTTP_METHOD.GET,
        Paths.FACE_DB + `/${type}?` + params,
        null,
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      return data;
    } catch (error: unknown) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  },
);
